import React from 'react'

function Hero() {
    return ( 
        <div className='container mt-5 mb-5'>
            <div className='row text-center'>
                <p className='fs-1'>Zerodha Products</p>
                <p className='text-muted  fs-3'>Sleek, modern, and intuitive trading platforms</p>
                <p className='mt-3 fs-5 text-muted' >Check out our <a href=""> investment offerings</a> →</p>
            </div>
        </div>
     );
}

export default Hero;